import React from "react";
import "./Footer.scss";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer bg-orange">
      <div className="container py-2 text-center">
        <div className="flex align-center justify-center text-white fw-3 fs-14">
          {/* <Link to="/seller" className="text-uppercase">
            privacy policy
          </Link>
          <div className="vert-line"></div>
          <Link to="/seller" className="text-uppercase">
            term of service
          </Link> */}
          {/* <div className="vert-line"></div>
          <Link to="/seller" className="text-uppercase">
            About Lpa.
          </Link> */}
          {/* <div className="vert-line"></div> */}
          <Link to="#" className="text-uppercase">
            &copy; 2024 Lpa. All Rights Reserved.
          </Link>
        </div>
        {/* <span className="text-white copyright-text text-manrope fs-14 fw-3"></span> */}
      </div>
    </footer>
  );
};

export default Footer;
